import { IAppState } from '../../../AppModulesWrapper';
import { selectIsPublishToHiddenBase } from '../publishAvailable';

export function selectIsPublicationAvailable(state: IAppState): boolean {
  const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

  if (isPublishToHiddenBase) {
    return true;
  }

  const { isPurchaseAvailable } = state.servicePickerWidget.checkoutInfo;

  return isPurchaseAvailable;
}
